import React from "react";
import { Switch, Route } from "react-router-dom";
import Main from "../pages/store/Main";
import Home from "../pages/store/Home";
import Products from "../pages/store/Products";
import ProductDetails from "../pages/store/ProductDetails";
import Cart from "../pages/store/Cart";
import Signin from "../pages/store/Signin";
import Signup from "../pages/store/Signup";
import Verify from "../pages/store/Verify";
import CartProvider from "../context/CartContext";
import Checkout from "../pages/store/Checkout";
import NotFound from "../pages/store/NotFound";
import Account from "../pages/store/Account";
import Template from "../pages/store/Template";

const Store = () => {
  return (
    <CartProvider>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/checkout/" component={Checkout} />
        <Route path="/cart" component={Cart} />
        <Route path="/shop" component={Main} />
        <Route path="/template" component={Template} />
        <Route path="/products/:collection" component={Products} />
        <Route path="/products/" component={Products} />
        <Route path="/product/:id" component={ProductDetails} />
        <Route path="/verification/:token" component={Verify} />
        <Route path="/signin" component={Signin} />
        <Route path="/signup" component={Signup} />
        <Route path="/account" component={Account} />
        <Route path="*" component={NotFound} />
      </Switch>
    </CartProvider>
  );
};

export default Store;
